<template>

        <div class="col-xl-6 col-12 d-flex flex-wrap justify-content-center justify-content-xl-start align-content-start align-items-start mt-0">
            <div class="col-xxl-8 col-10 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-4 mt-xl-0">
                Articulo
            </div>
            <div class="col-xxl-8 col-10 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-3 mt-xl-2">
                <div class="w-100 d-flex flex-wrap justify-content-center align-content-start align-items-start">
                    <div class="subtitleOption t-16 t-sm-13 t-xl-7 t-xxl-4 col-6 mb-2">1 - Giftcard </div><div class="dataImport t-16 t-sm-13 t-xl-7 t-xxl-4 col-6 text-end text-xl-start">$ {{this.formFields.step1.amount.value}}</div>
                    <div class="subtitleOption t-16 t-sm-13 t-xl-7 t-xxl-4 col-6 mb-2">Fecha de entrega:</div><div class="dataImport t-16 t-sm-13 t-xl-7 t-xxl-4 col-6 text-end text-xl-start">{{this.formFields.step3.receiverDate.date}}</div>
                    <div class="subtitleOption t-16 t-sm-13 t-xl-7 t-xxl-4 col-6 mb-2">Destinatario:</div><div class="dataImport t-16 t-sm-13 t-xl-7 t-xxl-4 col-6 text-end text-xl-start"><div class="w-100">{{capitalizeWords(this.formFields.step1.receiverName)}}</div><div class="w-100">{{this.formFields.step2.receiverWhatsapp}}</div></div>
                    <div class="subtitleOption t-16 t-sm-13 t-xl-7 t-xxl-4 col-6">Remitente:</div><div class="dataImport t-16 t-sm-13 t-xl-7 t-xxl-4 col-6 text-end text-xl-start"><div class="w-100">{{capitalizeWords(this.formFields.step4.senderName)}}</div><div class="w-100">{{this.formFields.step4.senderWhatsapp}}</div></div>
                    
                </div>
            </div>
            <div class="col-xxl-8 col-10 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-3 mt-xl-3">
                <stripe :formFields="formFields" :con="con" @result="filterResult"/>
            </div>
        </div>

</template>

<script>
import stripe from '@/components/common/stripe.vue'
export default {
    name: 'step6',
    emits:['setData', 'progress', 'showModal', 'setLoading', 'sendOrder'],
    components:{
        stripe,
    },
    props: {
        lang:{
            default:"es",
            type: String
        },
        con:{
            default:{},
            type: Object
        },
        formFields: {},
        cities:{
            default:[],
            type: Array
        }
    },
    methods:{
        setValue(step, field, value){
            let form = this.formFields[step];
            form[field] = value;
            this.$emit('setData', form, step);
        },
        step(step){
            this.$emit('progress', step);
        },
        filterResult(result){
            if (result.success) {
                this.setValue('step6', 'payConcreted', true);
                this.setValue('step6', 'payID', result.data.id);
                this.$emit('sendOrder');
            } else {
                this.$emit('setLoading', false)
                this.$emit('showModal', {type:'error', message:result.message, title:'Pago no realizado'});
            }
        }
    },
    mounted(){
        
    },  
    data() {
        return {
            simbol:require('@/assets/images/a27.svg'),
        }
    }
}
</script>

<style scoped lang="css">
.titleOption{
    color: var(--primary);
    font-weight: 600;
}
.cardDisabled .titleOption{
    opacity:0.5;
    pointer-events: none;
}
.cardDisabled input{
    opacity:0.5;
    pointer-events: none;
}
.subtitleOption{
    color: var(--sexagenary);
}
.inputText{
    border: 2px solid var(--quartenary);
    border-radius: 12px;
    padding: 10px;
    color: var(--primary);
}
textarea{
    resize: none;
}
.linkChange{
    color: var(--septagenary);
    cursor: pointer;
    font-weight: 700;
}
.linkChange:hover{
    color: var(--primary);
}

.commonPageCheckbox input:not(:checked) + label:hover{
    border:5px solid var(--secondary);
}
.commonPageCheckbox input:not(:checked) + label>span{
    display: none;
}
.commonPageCheckbox input{
    display: none;
}
.commonPageCheckbox label{
    cursor:pointer;
    width: 30px;
    height: 30px;
    border:3px solid var(--quinary);
    border-radius: 6px;
    overflow: visible;
}
.commonPageCheckbox img{
    width: 100%;
    height: 100%;
    margin-left: 15%;
    transform: scaleX(2.2) scaleY(2.2) translateY(-10%);
}
.commonPageCheckbox span{
    background-color: transparent;
}
.titleOption2{
    color: var(--primary);
    font-weight: 600;
}
.subtitleOption2{
    color: var(--sexagenary);
}
@media (min-width: 768px) {
    .commonPageCheckbox label{
        border:5px solid var(--quinary);
        width: 40px;
        height: 40px;
    }
}
.dataImport{
    color: var(--secondary);
}
</style>
